import styled from "styled-components";

export const StyledPage = styled.div`
    background-color: var(--ds-color-cloud);

    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
`;
